import logger from 'OK/logger';

var lcp; //lcp репортится множество раз в процессе рендеринга страницы. Нам надо запоминать последний.

function countFileSize() {
    var resources = performance.getEntriesByType("resource");
    var sizeByType = {};

    for(var i =0; i < resources.length; i++) {
        var resource = resources[i];
        var type = resource.initiatorType;
        sizeByType[type] = sizeByType[type] ? resource.transferSize + sizeByType[type] : resource.transferSize;
    }

    for (var type in sizeByType) {
        if (sizeByType.hasOwnProperty(type)) {
            OK.startupData["transferSize" + type] = sizeByType[type];
        }
    }
}

function collectPerfStats() {
    var startupData = OK.startupData;

    //сложить все NT метрики
    // Get start time from Navigation Timing API see:
    // https://w3c.github.io/navigation-timing/
    var timing = performance.timing;
    startupData['NT1'] = timing.domLoading                 - timing.fetchStart;        //time from fetch start to html parsing
    startupData['NT2'] = timing.domainLookupEnd            - timing.domainLookupStart; //domain lookup time
    startupData['NT3'] = timing.connectEnd                 - timing.connectStart;      //connection time
    startupData['NT4'] = timing.responseStart              - timing.requestStart;      //time to first byte
    startupData['NT5'] = timing.domLoading                 - timing.responseStart;     //time to download html
    startupData['NT6'] = timing.loadEventEnd               - timing.navigationStart;   //time from navigation start to end of onload event
    startupData['NT7'] = timing.domContentLoadedEventEnd   - timing.domLoading;        //time of html parsing, time from start dom loading to end of domContentLoaded event
    startupData['NT8'] = timing.domComplete                - timing.domInteractive;    //time of page processing
    startupData['NT9'] = timing.loadEventEnd               - timing.loadEventStart;    //onload event execution time

    try {
        var paintMetrics = performance.getEntriesByType("paint");
        if (Array.isArray(paintMetrics) && paintMetrics.length > 0) {
            startupData['NT10'] = paintMetrics[0].startTime; // Время отрисовки первого кадра
            if(paintMetrics.length > 1) {
                startupData['FCP'] = paintMetrics[1].startTime; // Время отрисовки первого осмысленного кадра
            }
        }
    } catch(e) {}

    startupData['domSize'] = document.body.getElementsByTagName('*').length;

    if(lcp && lcp > 0) {
        startupData['LCP'] = lcp;
    }

    //Данные из resource timing api
    try {
        countFileSize();
    } catch(e) {}

    //данные про ГВТ
    if(typeof __gwtStatsEventsLog !== 'undefined') {
        /* global __gwtStatsEventsLog */
        var gl = __gwtStatsEventsLog;
        startupData['gwt_boot']        = gl.bootstrap.end                 - gl.bootstrap.begin;
        startupData['gwt_modLoad']     = gl.moduleStartup.moduleEvalStart - gl.moduleStartup.moduleRequested;
        startupData['gwt_modEval']     = gl.moduleStartup.moduleEvalEnd   - gl.moduleStartup.moduleEvalStart;
        startupData['gwt_leftOvLoad']  = gl.leftoversDownload.end         - gl.leftoversDownload.begin;
    }
}

function registerLCP(){
    try {
        var po = new PerformanceObserver(function(entryList) {
            var entries = entryList.getEntries();
            var lastEntry = entries[entries.length - 1];
            lcp = lastEntry.renderTime || lastEntry.loadTime;
        });

        po.observe({type: 'largest-contentful-paint', buffered: true});

    } catch (e) {}
}

function activate() {
    registerLCP();
    OK.afterWindowOnloadAttach(
        function(){
            collectPerfStats();
            var stateId = OK.getCurrentDesktopModelId && OK.getCurrentDesktopModelId();
            for (var key in OK.startupData) {
                if (OK.startupData.hasOwnProperty(key)) {
                    logger.duration("startupData", OK.startupData[key], key, stateId);
                }
            }
        }
    );
}

export default { activate };

export { activate };
